
import React, { PureComponent } from 'react';

export default class ConnectorsIcon extends PureComponent {

    render() {
        const { color } = this.props
        return (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 2L16.5352 5.46484L15.6562 4.58594C15.0747 4.0044 14.3049 3.71289 13.5352 3.71289C12.7654 3.71289 11.9956 4.0044 11.4141 4.58594L9.20703 6.79297L8.41406 6L7 7.41406L6 8.41406L6.79297 9.20703L4.58594 11.4141C3.42286 12.5771 3.42286 14.4932 4.58594 15.6562L5.46484 16.5352L2 20L3.41406 21.4141L6.87891 17.9492L7.75781 18.8281C8.92089 19.9912 10.8369 19.9912 12 18.8281L14.207 16.6211L15 17.4141L16 16.4141L17.4141 15L16.6211 14.207L18.8281 12C19.9912 10.8369 19.9912 8.92089 18.8281 7.75781L17.9492 6.87891L21.4141 3.41406L20 2ZM13.5352 5.70117C13.7889 5.70117 14.0427 5.80054 14.2422 6L17.4141 9.17188C17.813 9.5708 17.813 10.187 17.4141 10.5859L15.207 12.793L10.6211 8.20703L12.8281 6C13.0276 5.80054 13.2814 5.70117 13.5352 5.70117ZM8.20703 10.6211L12.793 15.207L10.5859 17.4141C10.187 17.813 9.5708 17.813 9.17188 17.4141L6 14.2422C5.60107 13.8433 5.60107 13.2271 6 12.8281L8.20703 10.6211Z" fill={color}/>
            </svg>
        )
    }
}
